import React, { CSSProperties } from 'react';

export const useDragHelpers = (disabled: boolean = false) => {
  console.log('disabled useDragHelpers', disabled);
  const [isDragging, setIsDragging] = React.useState(false);

  const [position, setPosition] = React.useState({ x: 0, y: 0 });
  const [dragStart, setDragStart] = React.useState({ x: 0, y: 0 });

  const draggableContainerStyles: CSSProperties = {
    cursor: disabled ? 'auto' : isDragging ? 'grabbing' : 'grab',
  };

  const handleMouseDownDrag = (e: React.MouseEvent) => {
    if (disabled) {
      return;
    }
    e.preventDefault();
    setIsDragging(true);
    setDragStart({ x: e.clientX - position.x, y: e.clientY - position.y });
  };

  const handleMouseUp = () => {
    setIsDragging(false);
  };

  const handleMouseMove = React.useCallback(
    (e: MouseEvent) => {
      if (isDragging) {
        setPosition({
          x: e.clientX - dragStart.x,
          y: e.clientY - dragStart.y,
        });
      }
    },
    [dragStart.x, dragStart.y, isDragging]
  );
  React.useEffect(() => {
    if (isDragging) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isDragging, handleMouseMove]);
  return {
    isDragging,
    position,
    handleMouseDownDrag,
    draggableContainerStyles,
  };
};
